<template>
  <v-row v-bind="[$attrs]">
    <v-col cols="12">
      <h4 class="primary--text mb-2">{{ title }}</h4>
    </v-col>
    <slot />
  </v-row>
</template>

<script>
export default {
  name: "FormSection",
  props: {
    title: {
      type: String,
      default: ""
    }
  }
};
</script>
